// src/Pages/Projects.js

import './Projects.css';

// Importing card images
import halalaimusImg from '../Images/halalaimus_image.png';
import dotsEcoImg from '../Images/dots-eco-image.webp';
import logoImg from '../Images/articlesCovers/intertidal_lanice_patches.jpg';

const projectList =[
    {
    text: 'Academic outputs',
    image: logoImg,
    link: '/ScientificOutputs'
  },
  {
    text: 'Type location of the valid species of Halalaimus',
    image: halalaimusImg,
    link: '/NematodeMap'
  },
  {
    text: 'Blogs written for Dots.eco',
    image: dotsEcoImg,
    link: '/DotsEcoBlogs'
  }
];

const Projects = () => {
  return (
    <div className='projects'>
      {projectList.map((project, index) => (
        <a
          className='project-box'
          title={project.text}
          href={project.link}
          key={index}
          style={{ textDecoration: 'none', color: 'inherit' }} // preserve original styling
        >
          <div
            className='box-top'
            style={{ backgroundImage: `url(${project.image})` }}
          ></div>
          <div className='box-bottom'>
            {project.text}
          </div>
        </a>
      ))}
    </div>
  );
};

export default Projects;
